<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div  class="vx-col md:w-1/2  w-full mb-4">
        <span  class="title-page ml-6">{{$t('trial.manageJob')}}</span>
      </div>
      <!-- AgGrid Table -->
      <ag-grid-vue style="height: 55vh"
                   ref="agGridTable"
                   :components="components"
                   :gridOptions="gridOptions"
                   class="ag-theme-material w-100 my-4 ag-grid-table"
                   :columnDefs="columnDefs"
                   :defaultColDef="defaultColDef"
                   :rowData="jobList"
                   :animateRows="true"
                   :pagination="true"
                   :paginationPageSize="20"
                   :onGridReady="onGridReady"
                   :suppressPaginationPanel="true">
      </ag-grid-vue>

<!--      <vs-pagination-->
<!--        :total="totalPages"-->
<!--        :max="maxPageNumbers"-->
<!--        v-model="currentPage"/>-->
    </div>
  </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CellRendererActions from "@/views/admin-pages/trial-manage/cell-renderer/CellRendererActions";


export default {
  components: {
    AgGridVue,

    // Cell Renderer
  CellRendererActions
  },
  data() {
    return {
      searchQuery: "",
      maxPageNumbers: 6,
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {},
      columnDefs: [
        {
          headerName: 'ID',
          field: 'value',
          width: 50
        },
        {
          headerName: this.$t('trial.job'),
          field: 'label',
          width: 100
        },
        {
          headerName: 'Email',
          field: 'gmail',
          width: 110
        },

        {
          width: 130,
          cellRendererFramework: 'CellRendererActions',
        },
      ],
      // Cell Renderer Components
      components: {
        CellRendererActions,
      },
      jobList: [
        {label:'Bán lẻ & thương mại', value: 0, gmail : 'banlethuongmai@gmail.com'},
        {label: 'Bảo hiểm', value: 1, gmail : 'baohiem@gmail.com'},
        {label: 'Bất động sản', value: 3, gmail : 'batdongsan@gmail.com'},
        {label: 'CNTT & Viễn thông', value: 4, gmail : 'cnttvienthong@gmail.com'},
        {label: 'Dịch vụ công & nhà nước', value: 5, gmail : 'dichvucongvanhanuoc@gmail.com'},
        {label: 'Dịch vụ vận tải', value: 6, gmail : 'dichvuvantai@gmail.com'},
        {label: 'Dược và Y tế', value: 7, gmail : 'duocvayte@gmail.com'},
        {label: 'Fintech', value: 8, gmail : 'fintech@gmail.com'},
        {label: 'Giải trí', value: 9, gmail : 'giaitri@gmail.com'},
        {label: 'Giáo dục', value: 10, gmail : 'giaoduc@gmail.com'},
        {label: 'Giao nhận vận tải', value: 11, gmail : 'giaothongvantai@gmail.com'},
        {label: 'Khách sạn và nhà nghỉ', value: 12, gmail : 'khachsanvanhanghi@gmail.com'},
        {label: 'Làm đẹp, Mỹ phẩm & Sức khoẻ', value: 13, gmail : 'lamdepmyphamvasuckhoe@gmail.com'},
        {label: 'Luật/Pháp lý', value: 14, gmail : 'luatphaply@gmail.com'},
        {label: 'Năng lượng', value: 15, gmail : 'nangluong@gmail.com'},
        {label: 'Nông nghiệp', value: 16, gmail : 'nongnghiep@gmail.com'},
        {label: 'Quảng cáo/Truyền thông', value: 17, gmail : 'quangcaotruyenthong@gmail.com'},
        {label: 'Tài chính/Ngân hàng', value: 18, gmail : 'taichinhnganhang@gmail.com'},
        {label: 'Thực phẩm & Đồ uống', value: 19, gmail : 'thucphamdouong@gmail.com'},
        {label: 'Thương mại điện tử', value: 20, gmail : 'thuongmaidientu@gmail.com'},
        {label: 'Tiêu dùng nhanh', value: 21, gmail : 'tieudungnhanh@gmail.com'},
        {label: 'Xây dựng', value: 22, gmail : 'xaydung@gmail.com'},
        {label: 'Khác', value: -1, gmail : 'other@gmail.com'},
      ],
    }
  },
  created() {
    this.initScreen();
    this.$eventBus.$on('i18n', (event) =>{
      this.columnDefs[1].headerName =  this.$t('accountUser.nameUser');
      this.columnDefs[3].headerName =  this.$t('accountUser.phoneNum');
      this.columnDefs[4].headerName =  this.$t('accountUser.statusUser');
      this.columnDefs[5].headerName =  this.$t('accountUser.actionUser');
      this.gridOptions.api.setColumnDefs(this.columnDefs);

    })
  },
  watch: {
    '$store.state.windowWidth'(val) {
      if (val <= 1024) {
        this.maxPageNumbers = 5;
      } else {
        this.maxPageNumbers = 7;
      }

      if (val > 1024) {
        this.gridApi.sizeColumnsToFit();
      }
    },
    '$store.state.reduceButton'() {
      setTimeout(() => {
        this.gridApi.sizeColumnsToFit();
      }, 650);
    },
    '$store.state.isUpdateUser'(val) {
      if (val) {
        this.initScreen();
        this.$store.commit('UPDATE_USER_SUCCESS', false);
      }
    },
  },
  computed: {
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    onGridReady() {
      if (this.$store.state.windowWidth <= 1024) {
        this.maxPageNumbers = 5;
      } else {
        this.maxPageNumbers = 7;
      }

      if (this.$store.state.windowWidth > 1024) {
        this.gridApi.sizeColumnsToFit();
      }
    },
    initScreen() {
      setTimeout(() => {
        if (this.$store.state.windowWidth > 1024) {
          this.gridApi.sizeColumnsToFit();
        }
      }, 100);
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  }
}
</script>

<style scoped>
.title-page{
  font-size: 2.2rem;
  font-weight: bold;
}
</style>
